import { ACTIONS } from '../actions';

export const allEmergenciesReducer = (state = [], action) => {
    switch (action.type) {
        case ACTIONS.INITIALIZE_ALL_EMERGENCIES:
            return [...action.payload];
        case ACTIONS.ADD_TO_ALL_EMERGENCY:
            return [action.payload, ...state];
        case ACTIONS.UPDATE_EMERGENCY_FROM_ALL_EMERGENCIES:
            return state.map((e) => {
                if (e.id === action.payload.id) {
                    return action.payload;
                }
                return e;
            });
        default:
            return state;
    }
};
